import { IBaseProps } from './../../types/data';

export interface IOYDatePickerProps extends IBaseProps {
  /**
   * 时间类型
   */
  pickerType?: EDatePickerType;
  /**
   * 值
   */
  value?: string[]
}

export interface IOYDatePickerState {

}

export enum EDatePickerType {
  Date,
  DateRange
}



// WEBPACK FOOTER //
// ./src/components/OYDatePicker/const.ts